export default (theme) => ({
    root: {
        '& [class*="HoiPoi__SwitchInput__switchinput"]': {
            textAlign: 'start',
        },
    },
});
